export default __webpack_public_path__ + "static/media/saint-malo9.1eaccb65.jpg";